export const faqItems = [
  {
    question: 'Galgame资源网站PC上的游戏都是免费下载的吗？',
    answer: '是的，本站所有Galgame资源均提供免费下载。我们致力于为广大PC玩家提供最全面的Galgame游戏资源，包括汉化版、日文原版、补丁包和攻略合集，所有资源均经人工审核确保安全可用。',
  },
  {
    question: '下载的游戏支持哪些Windows系统？',
    answer: '本站资源主要支持Windows 7/10/11系统。每款游戏详情页都会标注具体的系统兼容性信息，下载前请确认您的系统版本。部分老游戏可能需要兼容模式运行，详情可参考对应游戏的安装说明。',
  },
  {
    question: '汉化补丁如何安装？',
    answer: '汉化补丁的安装方式因补丁类型而异：直接覆盖型补丁只需复制到游戏目录；安装程序型补丁运行安装向导即可；外挂式补丁需要额外运行加载程序。详细教程请查看本站的「汉化补丁安装教程」文章。',
  },
  {
    question: '网站上的资源更新频率是怎样的？',
    answer: '我们保持每日更新的节奏，新作发布后48小时内即可在本站找到资源。汉化补丁更新、版本修正等也会在第一时间同步。建议收藏本站或关注我们的更新通知，不错过任何新资源。',
  },
  {
    question: '游戏下载后遇到运行问题怎么办？',
    answer: '首先请确认您的系统满足游戏最低配置要求。常见问题包括缺少运行库（如DirectX、Visual C++）、杀毒软件误报、路径包含中文等。我们每款游戏页面下方都有常见问题解答区域，同时也可以在评论区与其他玩家交流。',
  },
  {
    question: '网站是否有移动端版本？',
    answer: '本站目前专注于PC版Galgame资源，网站本身支持移动端浏览器访问，但下载的游戏资源均适用于Windows PC平台。如需在移动设备上体验Galgame，请关注相关模拟器方案。',
  },
  {
    question: '如何第一时间获取新资源上架通知？',
    answer: '您可以通过本站的「新作速递」栏目查看最新上架的资源，也可以关注网站的更新日志。我们会在首页「最新更新」区域同步展示最近添加的资源，建议定期访问获取最新动态。',
  },
  {
    question: '网站上的攻略内容是否完整？',
    answer: '本站的攻略合集由资深Galgame玩家精心编写，涵盖全路线攻略、隐藏要素、CG解锁条件等完整内容。攻略持续更新中，如果您发现某款游戏的攻略不完整，欢迎通过联系表单反馈，我们会尽快补充。',
  },
  {
    question: '下载的Galgame游戏是否包含病毒？',
    answer: '安全是我们的首要原则。所有资源在上架前都经过多重安全检测，包括病毒扫描和文件完整性校验。我们使用正规渠道获取资源并进行安全封装，确保玩家下载的每一个文件都是安全可靠的。',
  },
];